import { en } from '../../i18n/translations/en'
import {
  buildBusinessSeatBuckets,
  buildPricingPlanCards,
  buildUpgradeMonthlyToYearlyProDialogMessage as buildUpgradeDialogFromI18n,
  getPricingCopy,
  mapPricingCopyToLegacy,
} from '../helpers/pricingI18n.helper'
import type { Translations } from '../../i18n/translations'
import type { BusinessSeatBucket, PricingPlanCard } from './pricingPlans.types'

/** English-default plan cards — tests and legacy call sites. Prefer usePricingI18n() in UI. */
export const PRICING_PLAN_CARDS: PricingPlanCard[] = buildPricingPlanCards(en)

export const PRICING_COPY = mapPricingCopyToLegacy(getPricingCopy(en))

export const BUSINESS_SEAT_BUCKETS: readonly BusinessSeatBucket[] = buildBusinessSeatBuckets(en)

export function buildUpgradeMonthlyToYearlyProDialogMessage(t: Translations = en): string {
  return buildUpgradeDialogFromI18n(t)
}
